var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinancialGoalsPlaceholder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 111,
    viewBox: "0 0 129 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1234_2980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.3606 102.743C71.7729 102.743 91.5629 98.4262 91.5629 93.1009C91.5629 87.7757 71.7729 83.4587 47.3606 83.4587C22.9483 83.4587 3.1582 87.7757 3.1582 93.1009C3.1582 98.4262 22.9483 102.743 47.3606 102.743Z",
    fill: "#4F4F4F",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7554 95.9794C22.19 95.9794 0.654419 74.4936 0.654419 47.9897C0.654419 21.4857 22.19 0 48.7554 0C75.3209 0 96.8564 21.4857 96.8564 47.9897C96.8564 74.4936 75.3209 95.9794 48.7554 95.9794Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7553 86.5405C27.4149 86.5405 10.1151 69.2807 10.1151 47.9897C10.1151 26.6987 27.4149 9.43896 48.7553 9.43896C70.0957 9.43896 87.3955 26.6987 87.3955 47.9897C87.3955 69.2807 70.0957 86.5405 48.7553 86.5405Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9564 67.7414C18.0224 56.8327 18.0224 39.1463 28.9564 28.2376C39.8904 17.3289 57.6179 17.3289 68.5519 28.2376C79.4859 39.1463 79.4859 56.8327 68.5519 67.7414C57.6179 78.6501 39.8904 78.6501 28.9564 67.7414Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4597 61.2532C28.1173 53.9279 28.1173 42.0511 35.4597 34.7258C42.802 27.4005 54.7062 27.4005 62.0486 34.7258C69.3909 42.0512 69.3909 53.9279 62.0486 61.2532C54.7062 68.5785 42.802 68.5785 35.4597 61.2532Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7555 57.1483C43.6856 57.1483 39.5756 53.0478 39.5756 47.9897C39.5756 42.9315 43.6856 38.8311 48.7555 38.8311C53.8253 38.8311 57.9353 42.9315 57.9353 47.9897C57.9353 53.0478 53.8253 57.1483 48.7555 57.1483Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.449 28.8851L122.85 30.5459L51.5044 47.7269L51.1026 46.0661L122.449 28.8851Z",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9037 39.9829L46.655 48.518L60.1562 49.1396L52.903 46.3232L55.9037 39.9829Z",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.372 25.4774L113.819 31.8386L119.293 34.2813L122.557 33.7932L120.946 32.3592L124.086 33.3031L128.086 32.3878L123.108 29.2148L122.851 24.4553L120.6 24.8825L119.499 27.0791L119.254 24.8214L117.372 25.4774Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6463 51.9119L119.353 82.4521L118.639 84.005L51.932 53.4648L52.6463 51.9119Z",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3743 51.5461L47.1788 50.8386L56.5689 58.3116L55.7929 54.1565L60.3743 51.5461Z",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.475 76.6438L110.738 79.4488L113.525 84.7441L116.394 86.3764L116.015 84.254L117.898 86.937L121.608 88.6856L119.664 83.1214L122.414 79.2219L120.38 78.1693L118.152 79.2161L119.36 77.2902L117.475 76.6438Z",
    fill: "#DCDCDC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1234_2980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 127.692,
    height: 111,
    fill: "white",
    transform: "matrix(-1 0 0 1 128.346 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancialGoalsPlaceholder);
export default __webpack_public_path__ + "static/media/FinancialGoalsPlaceholder.8717674c836f2c696cc8a3f788319bbd.svg";
export { ForwardRef as ReactComponent };